import { isSSR } from '@k2/core/util'
import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import { useApiLoad, useApiRequest } from '@/api'
import { type BrandMemory, useBrandMemoryResource } from '../resources'

const CLIENT = !isSSR

export const useBrandMemoryStore = defineStore('brand-memory', () => {
  const { getBrandMemory, delBrandMemoryFact } = useBrandMemoryResource()
  const { run, loading: acting, failure: actionFailure } = useApiRequest()
  const list = useApiLoad()
  const loading = computed(() => list.loading.value || acting.value)
  const failure = computed(() => list.failure.value ?? actionFailure.value)

  const memories = ref<Record<string, BrandMemory>>({})
  const forgetting = ref<string | null>(null)

  const loadMemory = async (organizationId: string, brandId: string) => {
    if (!CLIENT) return
    actionFailure.value = undefined
    const memory = await list.run<BrandMemory>(() => getBrandMemory(organizationId, brandId))
    if (memory) memories.value = { ...memories.value, [brandId]: memory }
  }

  const forget = async (organizationId: string, brandId: string, factId: string) => {
    forgetting.value = factId
    try {
      const forgot = await run<{ forgot: string }>(() => delBrandMemoryFact(organizationId, brandId, factId))
      const memory = memories.value[brandId]
      if (forgot && memory)
        memories.value = { ...memories.value, [brandId]: { ...memory, facts: memory.facts.filter(fact => fact.id !== factId) } }
    } finally {
      forgetting.value = null
    }
  }

  return { memories, loading, failure, forgetting, loadMemory, forget }
})
